import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

export function trackReferralLinkCopied() {
  trackLegacyEvent({
    name: SegmentObjectName.Referral,
    props: {
      action: SegmentActionName.ReferralLinkCopied,
    },
  });

  // V2 — referral_shared
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReferralShared,
    props: {},
  });
}

// referral
export function trackReferralLinkCreated() {
  trackLegacyEvent({
    name: SegmentObjectName.Referral,
    props: {
      action: SegmentActionName.ReferralLinkCreated,
    },
  });

  // V2 — referral_created
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReferralCreated,
    props: {},
  });
}
